"use client";

import { useEffect } from "react";
import useStore from "@/store/useStore";

export default function AuthProvider({ children }) {
  const initialize = useStore((state) => state.initialize);

  // Simply initialize on mount
  useEffect(() => {
    // Initialize auth - just get the session
    const cleanup = initialize();

    // Return cleanup function
    return () => {
      if (cleanup && typeof cleanup === "function") {
        cleanup();
      }
    };
  }, [initialize]);

  return children;
}
